{
  "name": "matrix",
  "version": "0.0.6",
  "versionDate": "2026-10-14",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration development",
    "start:local": "ng serve --configuration local",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "build:sandbox": "ng build --configuration sandbox",
    "build:develop-rs": "ng build --configuration develop-rs",
    "build:test": "ng build --configuration test",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "prepare": "husky install"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.0",
  "dependencies": {
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@ckeditor/ckeditor5-angular": "^11.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.2",
    "ckeditor5": "^47.4.0",
    "echarts": "^6.0.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "jspdf": "^4.0.0",
    "jspdf-autotable": "^5.0.7",
    "ngx-echarts": "^21.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.2",
    "rxjs": "~7.8.2",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0",
    "video.js": "^8.23.7"
  },
  "devDependencies": {
    "@angular/build": "^21.0.2",
    "@angular/cli": "^21.0.2",
    "@angular/compiler-cli": "^21.0.0",
    "@tailwindcss/postcss": "^4.1.18",
    "husky": "^9.0.11",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.6",
    "tailwindcss": "^4.1.18",
    "typescript": "~5.9.3",
    "vitest": "^4.0.17"
  }
}
